export function createRoutes({
  middlewareAuth,
  middlewareGuest,
  middlewareStoreAdmin,
}) {
  return [
    {
      path: "/",
      name: "HomePage",
      component: () => import("../../views/Home/Home.vue"),
      beforeEnter: middlewareGuest,
      meta: {
        description:
          "Descubra modelos 3D, impressoras e materiais para impressão. Acesse agora o MakerMarket.",
      },
    },
    {
      path: "/login",
      name: "LoginPage",
      component: () => import("../../views/Login/Login.vue"),
      beforeEnter: middlewareGuest,
      meta: {
        title: "Entrar",
        description:
          "Acesse sua conta para comprar, vender ou gerenciar modelos 3D no MakerMarket.",
      },
    },
    {
      path: "/auth/pass",
      name: "ResetPasswordPage",
      component: () => import("../../views/Login/ResetPassword.vue"),
      meta: {
        title: "Redefinir senha",
        description: "Recupere o acesso a sua conta.",
      },
    },
    {
      path: "/faq",
      name: "FaqPage",
      component: () => import("../../views/Faq/FaqPage.vue"),
      meta: {
        title: "Fale Conosco",
        description:
          "Dúvidas frequentes sobre uso da plataforma, compras, vendas e segurança.",
      },
    },
    {
      path: "/contato",
      name: "ContactPage",
      component: () => import("../../views/Contact/ContactPage.vue"),
      meta: {
        title: "Contato",
        description:
          "Entre em contato conosco para dúvidas, suporte e feedback. Estamos aqui para ajudar você a aproveitar ao máximo o MakerMarket.",
      },
    },
    {
      path: "/calculadora",
      name: "CalculatorPage",
      component: () => import("../../views/Calculator/CalculatorPage.vue"),
      meta: {
        title: "Cotar",
        description: "Faça cotações com base nos dados do seu modelo",
      },
    },
    {
      path: "/calculadora/minhas-cotacoes",
      name: "MyQuotationsPage",
      component: () => import("../../views/Calculator/MyQuotations.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Minhas Cotações",
        description: "Visualize e administre as cotações feitas por você.",
      },
    },
    {
      path: "/usuario/:username/:id",
      name: "UserProfilePage",
      component: () => import("../../views/Account/UserDetails.vue"),
      props: true,
    },
    {
      path: "/loginUserByToken",
      name: "LoginByToken",
      component: () => import("../../views/Login/LoginByToken.vue"),
    },
    {
      path: "/dashboard",
      name: "DashboardPage",
      component: () => import("../../views/Dashboard/Dashboard.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Início",
        description:
          "Painel principal com resumo das suas atividades, modelos favoritos, pedidos e notificações.",
      },
    },
    {
      path: "/legal/politica-de-privacidade",
      name: "PrivacyPolicy",
      component: () => import("../../views/Legal/PrivacyPolicy.vue"),
      meta: {
        title: "Política de Privacidade",
        description:
          "Saiba como seus dados são utilizados e protegidos no MakerMarket.",
      },
    },
    {
      path: "/legal/termos-de-uso",
      name: "TermsOfUse",
      component: () => import("../../views/Legal/TermsOfUse.vue"),
      meta: {
        title: "Termos de Uso",
        description:
          "Veja os termos que regem o uso da plataforma MakerMarket.",
      },
    },
    {
      path: "/catalogo",
      name: "CatalogPage",
      component: () => import("../../views/Catalog/Catalog.vue"),
      meta: {
        title: "Catálogo de Modelos",
        description:
          "Explore milhares de modelos 3D prontos para imprimir. Filtre por categoria, tags e mais.",
      },
    },
    {
      path: "/checkout",
      name: "CheckoutPage",
      component: () => import("../../views/Checkout/CheckoutPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Checkout",
        description:
          "Confira os modelos e produtos adicionados ao seu carrinho e finalize sua compra.",
      },
    },
    {
      path: "/admin",
      name: "AdminHomePage",
      component: () => import("../../views/Admins/AdminHomePage.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Área administrativa",
      },
    },
    {
      path: "/admin/financeiro/a-pagar",
      name: "AvailablePaymentsTab",
      component: () =>
        import("../../views/Admins/Financial/AvailablePaymentsTab.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Financeiro | Comissões a pagar",
      },
    },
    {
      path: "/admin/financeiro/pagos",
      name: "PaidCommissionsTab",
      component: () =>
        import("../../views/Admins/Financial/PaidCommissionsTab.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Financeiro | Comissões pagas",
      },
    },
    {
      path: "/admin/financeiro/bloqueados",
      name: "BlockedPaymentsTab",
      component: () =>
        import("../../views/Admins/Financial/BlockedPaymentsTab.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Financeiro | Comissões bloqueadas",
      },
    },
    {
      path: "/admin/solicitacoes/problemas-modelos",
      name: "RequestModelsProblems",
      component: () =>
        import("../../views/Admins/Requests/RequestModelsProblems.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Solicitações | Itens Reportados",
      },
    },
    {
      path: "/admin/solicitacoes/impressoras-requisitadas",
      name: "RequestPrinters",
      component: () =>
        import("../../views/Admins/Requests/RequestPrinters.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Solicitações | Impressoras",
      },
    },
    {
      path: "/admin/solicitacoes/insumos-requisitados",
      name: "RequestSupplies",
      component: () =>
        import("../../views/Admins/Requests/RequestSupplies.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Solicitações | Insumos",
      },
    },
    {
      path: "/admin/estatisticas/mais-vendidos",
      name: "BestSellers",
      component: () => import("../../views/Admins/AdminBestSeller.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Mais Vendidos",
      },
    },
    {
      path: "/admin/financeiro",
      redirect: "/admin/financeiro/a-pagar",
    },
    {
      path: "/admin/visao-geral",
      name: "AdminPage",
      component: () => import("../../views/Admins/OverviewPage.vue"),
      beforeEnter: [middlewareAuth, middlewareStoreAdmin],
      meta: {
        requiresAuth: true,
        title: "Painel do Administrador",
        description:
          "Gerencie usuários, modelos, pedidos e pagamentos como administrador da plataforma.",
      },
      children: [
        {
          path: "",
          redirect: { name: "AdminsUsersPage" },
        },
        {
          path: "usuarios",
          name: "AdminsUsersPage",
          component: () => import("../../views/Admins/AdminsUsersPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Usuários",
            description:
              "Visualize e administre os usuários cadastrados na plataforma.",
          },
        },
        {
          path: "usuarios/login",
          name: "AdminsLoginTokensPage",
          component: () =>
            import("../../views/Admins/Users/AdminsLoginTokensPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Status de Login",
            description:
              "Visualize os status de login dos usuários na plataforma.",
          },
        },
        {
          path: "calculadora",
          name: "AdminCalculator",
          component: () => import("../../views/Admins/AdminCalculator.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Calculadora",
            description: "Calcule o preço de um produto específico",
          },
        },
        {
          path: "pedidos",
          name: "AdminsOrdersPage",
          component: () => import("../../views/Admins/AdminsOrdersPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Pedidos",
            description:
              "Gerencie os pedidos realizados por usuários da plataforma.",
          },
        },
        {
          path: "pagamentos",
          name: "AdminsPaymentsPage",
          component: () => import("../../views/Admins/AdminsPaymentsPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Pedidos",
            description:
              "Acompanhe os pagamentos e transações financeiras da plataforma.",
          },
        },
        {
          path: "etiquetas",
          name: "AdminsTicketsPage",
          component: () => import("../../views/Admins/AdminsTicketsPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Pedidos",
            description: "Visualize e gerencie as etiquetas de envio geradas.",
          },
        },
        {
          path: "modelos",
          name: "AdminsModelsPage",
          component: () => import("../../views/Admins/AdminsModelsPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Modelos",
            description: "Administre os modelos 3D enviados pelos usuários.",
          },
        },
        {
          path: "modelos/novo",
          name: "AdminModelsNewWrapperPage",
          component: () =>
            import("../../views/Admins/AdminModelsNewWrapperPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Modelos",
            description: "Adicione novos modelos na plataforma.",
          },
        },
        {
          path: "modelos/:id/editar",
          name: "AdminsModelsNewPage",
          component: () => import("../../views/Admins/AdminsModelsNewPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Editar Modelo",
            description: "Edite os dados de um modelo publicado na plataforma.",
          },
        },
        {
          path: "modelos/:id/editar/parcial",
          name: "AdminsModelsEditPage",
          component: () =>
            import("../../views/Admins/AdminsModelsEditPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Editar Modelo",
            description: "Edite os dados de um modelo publicado na plataforma.",
          },
        },
        {
          path: "cotacoes-arquivos",
          name: "AdminsFileQuotationsPage",
          component: () => import("../../views/Admins/AdminFileQuotations.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Cotações de Arquivos",
            description:
              "Visualize e administre as cotações de arquivos geradas na plataforma.",
          },
        },
        {
          path: "usuarios/:id/edit",
          name: "AdminsUsersEditPage",
          component: () => import("../../views/Admins/AdminsUsersEditPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Editar Usuário",
            description:
              "Altere informações dos usuários diretamente pelo painel.",
          },
        },
        {
          path: "/admin/visao-geral/cupons",
          name: "AdminsCouponsPage",
          component: () =>
            import("../../views/Admins/Coupons/AdminsCouponsPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Cupons",
            description: "Visualize os cupons diretamente pelo painel.",
          },
        },
        {
          path: "/admin/visao-geral/cupons/novo",
          name: "AdminsCouponsCreatePage",
          component: () =>
            import("../../views/Admins/Coupons/AdminsCouponsCreatePage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Criar Cupom",
            description: "Adicione cupons diretamente pelo painel.",
          },
        },
        {
          path: "/admin/visao-geral/cupons/utilizacoes",
          name: "AdminsCouponsViewPage",
          component: () =>
            import("../../views/Admins/Coupons/AdminsCouponsViewPage.vue"),
          beforeEnter: [middlewareAuth, middlewareStoreAdmin],
          meta: {
            requiresAuth: true,
            title: "Cupons Utilizados",
            description:
              "Visualize a utilização de cupons em pedidos diretamente pelo painel.",
          },
        },
      ],
    },
    {
      path: "/impressoras",
      name: "PrintersPage",
      component: () => import("../../views/Printers/PrintersPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Impressoras",
        description: "Gerencie suas impressoras 3D cadastradas na plataforma.",
      },
      children: [
        {
          path: "armazenamento",
          name: "MyPrinters",
          component: () => import("../../views/Printers/MyPrinters.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Minhas Impressoras",
            description:
              "Veja e edite as impressoras 3D que você adicionou ao seu perfil.",
          },
        },
        {
          path: "selecionar",
          name: "AssociatePrinter",
          component: () => import("../../views/Printers/AssociatePrinter.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Selecionar Impressora",
            description:
              "Associe uma impressora 3D aos seus modelos ou pedidos.",
          },
        },
        {
          path: "adicionar",
          name: "AddPrinter",
          component: () => import("../../views/Printers/AddPrinter.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Adicionar Impressora",
            description:
              "Cadastre uma nova impressora 3D com suas especificações.",
          },
        },
        {
          path: "dados",
          name: "InfoPrinter",
          component: () => import("../../views/Printers/InfoPrinter.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Verificar Impressora",
            description:
              "Visualize os dados completos da impressora selecionada.",
          },
        },
        {
          path: "fila",
          name: "PrinterQueue",
          component: () =>
            import("../../views/Printers/PrinterQueue/PrinterQueue.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Fila de Impressão",
            description: "Visualize a fila de impressão.",
          },
        },
        {
          path: "fila/:printerUserId",
          name: "PrinterQueueByPrinter",
          component: () =>
            import(
              "../../views/Printers/PrinterQueue/PrinterQueueByPrinter.vue"
            ),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Fila de Impressão",
            description: "Visualize a fila de impressão.",
          },
        },
      ],
    },
    {
      path: "/pedidos",
      name: "OrdersPage",
      component: () => import("../../views/Orders/OrdersPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Pedidos",
        description:
          "Gerencie todos os seus pedidos de impressão 3D em um só lugar.",
      },
      children: [
        {
          path: "aceitos",
          name: "OrdersApproved",
          component: () => import("../../views/Orders/OrdersApproved.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Pedidos Aceitos",
            description:
              "Acompanhe os pedidos que você aceitou como Maker e está produzindo.",
          },
        },
        {
          path: "recusados",
          name: "OrdersReproved",
          component: () => import("../../views/Orders/OrdersReproved.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Pedidos Reprovados",
            description: "Veja os pedidos recusados e os motivos da recusa.",
          },
        },
        {
          path: "pendentes",
          name: "OrdersPendents",
          component: () => import("../../views/Orders/OrdersPendents.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Pedidos Pendentes",
            description:
              "Confira os pedidos aguardando ação. Aceite ou recuse conforme necessário.",
          },
        },
        {
          path: "concluidos",
          name: "OrdersCompleted",
          component: () => import("../../views/Orders/OrdersCompleted.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Pedidos Concluídos",
            description: "Acompanhe os pedidos já finalizados e entregues.",
          },
        },
        {
          path: "lojista",
          name: "OrdersRetailerAccepted",
          component: () => import("../../views/Orders/OrdersStorekeeper.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Compras",
            description:
              "Visualize suas compras feitas como Lojista na plataforma.",
          },
        },
        {
          path: "duvidas",
          name: "MakerHowTo",
          component: () => import("../../views/Faq/FaqMakers.vue"),
          meta: {
            requiresAuth: true,
            title: "Dúvidas de Impressão",
            description:
              "Dúvidas com o pedido? Veja as perguntas frequentes dos Makers.",
          },
        },
      ],
    },
    {
      path: "/lojas",
      name: "StorePage",
      component: () => import("../../views/Stores/StoresPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Lojas",
        description: "Gerencie suas lojas virtuais dentro do MakerMarket.",
      },
      children: [
        {
          path: "minhas",
          name: "MyStores",
          component: () => import("../../views/Stores/MyStores.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Minhas Lojas",
            description: "Acesse e edite suas lojas já cadastradas.",
          },
        },
        {
          path: "adicionar",
          name: "AddStore",
          component: () => import("../../views/Stores/AddStore.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Adicionar Loja",
            description: "Crie uma nova loja para vender seus produtos.",
          },
        },
        {
          path: "editar/:id",
          name: "EditStore",
          component: () => import("../../views/Stores/EditStore.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Editar Loja",
            description: "Atualize os dados da sua loja existente.",
          },
        },
      ],
    },
    {
      path: "/modelos",
      name: "ModelsPage",
      component: () => import("../../views/Models/ModelsPage.vue"),
      meta: {
        title: "Modelos",
      },
      children: [
        {
          path: "dados",
          name: "MyDesigns",
          component: () => import("../../views/Models/Designer/MyDesigns.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Meus Modelos",
            description:
              "Gerencie seus modelos 3D para impressão compartilhados na plataforma.",
          },
        },
        {
          path: "editar",
          name: "EditModel",
          component: () => import("../../views/Models/EditModel.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Editar Modelo",
            description: "Visualize e edite os modelos 3D que você publicou.",
          },
        },
        {
          path: "adicionar",
          name: "AddModel",
          component: () => import("../../views/Models/AddModel.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Adicionar Modelo",
            description:
              "Cadastre um novo modelo 3D com imagens, arquivos e descrição.",
          },
        },
        {
          path: ":slug/:id/",
          name: "ModelDetails",
          component: () => import("../../views/Models/ModelDetails.vue"),
          meta: {
            title: "Detalhes do Modelo",
            description: "Atualize informações de um modelo 3D já cadastrado.",
          },
        },
      ],
    },
    {
      path: "/insumos",
      name: "SuppliesPage",
      component: () => import("../../views/Supplies/SuppliesPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Insumos",
        description:
          "Veja todas as informações, comentários e arquivos de um modelo específico.",
      },
      children: [
        {
          path: "estoque",
          name: "MySupplies",
          component: () => import("../../views/Supplies/MySupplies.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Meus Insumos",
            description:
              "Gerencie seus filamentos, resinas e outros materiais cadastrados.",
          },
        },
        {
          path: "adicionar",
          name: "AddSupplies",
          component: () => import("../../views/Supplies/AddSupplies.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Adicionar Insumo",
            description:
              "Veja e edite os materiais que você possui em estoque.",
          },
        },
        {
          path: "editar",
          name: "EditSupplies",
          component: () => import("../../views/Supplies/EditSupplies.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Adicionar Insumo",
            description: "Cadastre novos insumos para uso em impressões.",
          },
        },
        {
          path: "selecionar",
          name: "AssociateSupplies",
          component: () => import("../../views/Supplies/AssociateSupplies.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Selecionar Insumos",
            description: "Associe insumos às suas impressoras e modelos.",
          },
        },
      ],
    },
    {
      path: "/carteira",
      name: "WalletPage",
      component: () => import("../../views/Wallet/WalletPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Carteira",
        description:
          "Gerencie seu saldo, transações e histórico financeiro na plataforma.",
      },
    },
    {
      path: "/modelo",
      name: "ModelPage",
      component: () => import("../../views/Models/ModelDetails.vue"),
      meta: {
        title: "Modelo",
      },
    },
    {
      path: "/favoritos",
      name: "FavoritesPage",
      component: () => import("../../views/Favorites/Favorites.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Favoritos",
        description:
          "Visualize seus modelos favoritos salvos para impressão futura.",
      },
    },
    {
      path: "/pedidos/tentativas-impressao/:orderId",
      name: "OrderPrintAttemptsPage",
      component: () =>
        import("../../views/Orders/OrderAttempts/OrderPrintAttemptsPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Tentativas de Impressão",
        description:
          "Visualize o histórico de tentativas de impressão para seus pedidos.",
      },
    },
    {
      path: "/conta",
      name: "AccountPage",
      component: () => import("../../views/Account/AccountPage.vue"),
      beforeEnter: middlewareAuth,
      meta: {
        requiresAuth: true,
        title: "Conta",
        description:
          "Acesse e edite suas informações pessoais, senhas e preferências.",
      },
      children: [
        {
          path: "editar",
          name: "EditProfile",
          component: () => import("../../views/Account/EditProfile.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Editar Perfil",
            description:
              "Atualize seus dados pessoais, senha e preferências de perfil.",
          },
        },
        {
          path: "enderecos",
          name: "MyAddressesPage",
          component: () => import("../../views/Account/MyAddresses.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Meus Endereços",
            description:
              "Gerencie seus endereços de entrega e cobrança para compras no MakerMarket.",
          },
        },
      ],
    },
    {
      path: "/cadastro",
      name: "RegisterPage",
      component: () => import("../../views/Register/Register.vue"),
      meta: {
        title: "Cadastro",
        description:
          "Crie sua conta para começar a vender, comprar ou compartilhar modelos 3D.",
      },
      children: [
        {
          path: "informacoes",
          name: "ProfileInformations",
          component: () =>
            import("../../views/Register/ProfileInformations.vue"),
          beforeEnter: middlewareGuest,
          meta: {
            title: "Informações Adicionais",
          },
        },
        {
          path: "verificacao",
          name: "VerificationOtp",
          component: () => import("../../views/Register/OTP.vue"),
          beforeEnter: middlewareAuth,
          meta: {
            requiresAuth: true,
            title: "Informações Verificação",
          },
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("../../components/templates/NotFound.vue"),
      meta: {
        title: "Página não encontrada",
      },
    },
  ];
}
